import { useCallback, useState } from 'react'
import { debounce } from 'lodash'
import { useQuery } from '@apollo/client'
import { DEBOUNCE_DELAY } from 'constants/consts'
import {
  findSubjectByPlatform,
  findSubjectByPlatform_findSubjectByPlatform_tabs as Subject,
  findSubjectByPlatformVariables,
} from '__generatedTypes__/findSubjectByPlatform'
import { FIND_SUBJECT_BY_PLATFORM } from 'queries/subject'
import { SubjectEnumType, TaskTypeEnum } from '__generatedTypes__/globalTypes'

export type TasksFilters = {
  type: {
    id: TaskTypeEnum
    title: TaskTypeEnum
  }
  subject: {
    id: string
    title: string
  }
}
export type UseQuestionFilters = {
  [key in keyof TasksFilters]: {
    items: Array<TasksFilters[key]>
    search: (value: string) => void
    loading: boolean
  }
}

export const ALL_SUBJECT_ID = 'All'

export const ALL_SUBJECT = {
  __typename: 'SubjectTabType' as const,
  id: ALL_SUBJECT_ID,
  tabName: 'All',
  type: SubjectEnumType.Regular,
  slug: 'all',
}

export const useTaskFilters = (platformId: string): UseQuestionFilters => {
  const [subjects, setSubjects] = useState<Subject[]>([])

  const { data: subjectData, loading: loadingSubjects } = useQuery<
    findSubjectByPlatform,
    findSubjectByPlatformVariables
  >(FIND_SUBJECT_BY_PLATFORM, {
    variables: { platformId },
    onCompleted: (data) => {
      setSubjects([...(data?.findSubjectByPlatform?.tabs || []), ALL_SUBJECT])
    },
  })

  const allSubjects = [...(subjectData?.findSubjectByPlatform?.tabs || []), ALL_SUBJECT]

  const searchSubject = useCallback(
    debounce((searchString: string) => {
      const search = searchString.trim()
      setSubjects(
        allSubjects.filter((subject) => {
          const subjectName = subject.tabName.toLowerCase()
          return subjectName.includes(search)
        })
      )
    }, DEBOUNCE_DELAY),
    []
  )

  return {
    type: {
      items: Object.values(TaskTypeEnum)
        .filter((type) => type !== TaskTypeEnum.Custom)
        .map((type) => ({
          id: type,
          title: type,
        })),
      search: () => undefined,
      loading: false,
    },
    subject: {
      items: subjects.map((subject) => ({
        id: subject.id,
        title: subject.tabName,
      })),
      search: searchSubject,
      loading: loadingSubjects,
    },
  }
}
